import {
    isValidMachineSubType,
    MachineSubType,
    MachineType,
} from '@internal/utils/machine/MachineType';
import { FormControlLabel, Radio, RadioGroup } from '@renderer-ui-library/mui';
import React, { useCallback } from 'react';
import { tracker } from 'utils/tracking/tracker';
import { TFilterOption } from '../FilteredList/TFilterOption';

type Props = {
    value: MachineSubType | null;
    options: TFilterOption[];
    onChange: (machineSubType: MachineSubType | null) => void;
    machineType: MachineType | undefined;
};

export const MachineSubTypeSelectFilter: React.FC<Props> = React.memo(
    ({ onChange, value, options, machineType }) => {
        const handleRadioClick = useCallback(
            (ev: React.MouseEvent<HTMLButtonElement>) => {
                let targetValue: MachineSubType | string | null = (
                    ev.target as HTMLButtonElement
                ).value;
                if (
                    !machineType ||
                    !isValidMachineSubType(targetValue, machineType)
                ) {
                    return;
                }

                const newValue = targetValue === value ? null : targetValue;
                onChange(newValue);

                if (newValue) {
                    tracker.trackEvent({
                        name: 'filter-applied',
                        filter_placement: 'serp',
                        filter_category: 'machine-sub-type',
                        filter_machine_sub_type: newValue,
                        is_interaction: true,
                    });
                }
            },
            [machineType, onChange, value],
        );

        return (
            <RadioGroup value={value ?? ''}>
                {options.map(option => (
                    <FormControlLabel
                        key={option.id}
                        value={option.id}
                        control={
                            <Radio onClick={handleRadioClick} size="small" />
                        }
                        label={option.label}
                    />
                ))}
            </RadioGroup>
        );
    },
);

MachineSubTypeSelectFilter.displayName = 'MachineSubTypeSelectFilter';
